import { render, staticRenderFns } from "./UserMixin.vue?vue&type=template&id=3b054937&"
import script from "./UserMixin.vue?vue&type=script&lang=js&"
export * from "./UserMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports